import { Outlet, createFileRoute } from '@tanstack/react-router'

/** Layout for the event-types section: the index grid + the `$id` editor render here. */
export const Route = createFileRoute('/_authed/bookings/event-types')({
  component: () => <Outlet />,
})
